import 'ui-core/components/figure-viewer/js/figure-viewer-script';
import GoToSection from '../../go-to-section/js/goToSection';
import {keyCodes} from '../../../utility/js/utils';

(function () {
    const figureViewer = UX.figureViewer;
    const figureNumbers = document.querySelectorAll('.figure__image');
    let nodesToBeDisabled = [];

    figureViewer.removeFigureTitle = function () {};

    figureViewer.additionalBrowse = function () {
        if ($('#pane-pcw-figures').hasClass('empty')) {
            figureViewer.$browseContainer.empty();
            figureViewer.$figures.each(function () {
                let $fig = $(this).clone(true);
                let $figureLinks = $fig.find('.figure-links');

                if ($figureLinks.length) {
                    $figureLinks.remove();
                }
                figureViewer.$browseContainer.append($fig);
            });
        }
    };

    figureViewer.height = function (element) {
        let $windowsHeight = $(window).innerHeight();
        figureViewer.$topRegHeight = $('.figure-viewer__reg__top').innerHeight();
        let $height = $windowsHeight - figureViewer.$topRegHeight; //LIT-360726
        if (figureViewer.isMobile) {
            $height -= figureViewer.$captionRegion.find('.figure-viewer__title').height();
            const captionRegion = document.querySelector('.figure-viewer__cent__right');
            if (captionRegion) {
                captionRegion.style.height = `${$height}px`;
            }
        }
        $('.figure-viewer__cent__left').find('figure').height($height);
    };

    figureViewer.on.additionalOnShow = function () {
        const figureViewer = document.querySelector('.figure-viewer');

        UX.utils.focusCycleInitiator(figureViewer);
        const adFocusableEl = document.querySelector('.js--adFocusableEl');
        if (adFocusableEl && adFocusableEl.tabIndex === -1) {
            adFocusableEl.tabIndex = 0;
        }
        nodesToBeDisabled = UX.utils.disableNodes(figureViewer);

        if (figureViewer.querySelector('.figure__highResImgReplacer'))
            figureViewer.addEventListener('click', function () {
                const zoomIn = figureViewer.querySelector('.zoom-in');
                zoomIn.click();
            });
    };

    figureViewer.on.additionalOnHide = function () {
        const adFocusableEl = document.querySelector('.js--adFocusableEl');
        if (adFocusableEl && adFocusableEl.tabIndex === 0) {
            adFocusableEl.tabIndex = -1;
        }
        nodesToBeDisabled.forEach(element => {
            element.inert = false;
        });
        figureViewer.$focusedElementBeforeOpened.focus();
    };

    if (figureNumbers.length === 1) {
        figureViewer.$figureNav.hide();
    }

    figureViewer.additionalReplace = function () {
        const goToSection = new GoToSection();
        const figure = document.getElementById('figure-viewer');
        const figureImage = figure?.querySelector('.figure__image');
        const sectionImages = figure?.querySelectorAll('.section_image');
        const imageType = figureImage?.src?.split('.').pop().trim();
        const figureCaptionLinks = UX.utils.convertToArray(
            figure?.querySelectorAll('.figure-viewer__hold__figcap a:not(.linkBehavior)')
        );
        figureCaptionLinks?.forEach(link => {
            link.addEventListener('click', e => {
                figureViewer.on.hide();
                goToSection?.flowControl(e);
            });
        });

        if (imageType === 'svg') {
            fetch(figureImage.src)
                .then(response => response.text())
                .then(svgText => {
                    const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    svgElement.innerHTML = svgText;

                    const feFlood = svgElement?.querySelector('feFlood');
                    const floodColor = feFlood?.getAttribute('flood-color');
                    if (!floodColor) {
                        figureImage.classList.add('bg-white');
                    }
                })
                .catch(error => console.error(error));
        }

        sectionImages?.forEach(image => {
            const canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;

            // Draw the image on the canvas
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0);

            // Get the pixel data of the top-left corner (0,0) on the canvas
            const pixelData = context.getImageData(0, 0, 1, 1).data;
            if (pixelData[0] === 0 && pixelData[1] === 0 && pixelData[2] == 0) {
                image.classList.add('bg-white');
            }
        });
    };

    figureViewer.zoom.panzoom = {
        // zoom in functionality
        init: function () {
            if (typeof $.fn.panzoom != 'undefined') {
                figureViewer.$image.panzoom({
                    $zoomIn: figureViewer.$zoominbtn,
                    $zoomOut: figureViewer.$zoomoutbtn,
                    $zoomRange: figureViewer.$zoomrange,
                    $reset: figureViewer.$zoomreset,
                    panOnlyWhenZoomed: false,
                    minScale: 1,
                });
                const directionControls = document.querySelector('.direction-control');
                figureViewer.$image.on('panzoomchange', function (e) {
                    if (figureViewer.$zoomrange.val() === '1') {
                        figureViewer.$image.css('transform', 'matrix(1, 0, 0, 1, 0, 0)');
                        $(this).removeClass('zoomed');
                        directionControls.classList.add('hidden');
                    } else {
                        $(this).addClass('zoomed');
                        directionControls.classList.remove('hidden');
                        const figureViewer = document.querySelector('.figure-viewer');

                        UX.utils.focusCycleInitiator(figureViewer);
                    }
                });
            }
        },
    };

    const inlineEquations = document.querySelectorAll('.inline-equation__construct .figure__image');
    inlineEquations?.forEach(equation => {
        if (!equation.closest('.figure')) {
            equation.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
            });
        }
    });
    const STEP_MOVE = 50;

    const updateMatrix = (matrixStr, direction) => {
        const matrixValues = matrixStr.match(/[-0-9.]+/g).map(Number);

        switch (direction) {
            case 'up':
                matrixValues[5] -= STEP_MOVE;
                break;

            case 'down':
                matrixValues[5] += STEP_MOVE;
                break;

            case 'left':
                matrixValues[4] -= STEP_MOVE;
                break;

            case 'right':
                matrixValues[4] += STEP_MOVE;
                break;

            default:
                break;
        }

        return `matrix(${matrixValues.join(', ')})`;
    };

    const moveControlHandler = e => {
        const figure = document.querySelector('.figure-viewer__hold__fig figure');
        let originalMatrix = '';
        if (figure.style.transform === 'none') {
            originalMatrix = 'matrix(1, 0, 0, 1, 0, 0)';
        } else {
            originalMatrix = figure.style.transform;
        }
        const direction = e.target.getAttribute('direction');
        figure.style.transform = updateMatrix(originalMatrix, direction);
    };

    document.querySelectorAll('.direction-control span').forEach(control => {
        control.addEventListener('click', e => moveControlHandler(e));
        control.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.keyCode === keyCodes.RETURN || e.key === ' ' || e.keyCode === keyCodes.SPACE) {
                moveControlHandler(e);
            }
        });
    });
})();
